import PropTypes from 'prop-types';
import { mainBarPropTypes } from './components/MainBar/MainBarPropTypes';
import { promoBarPropTypes } from '@Theme/natucare/modules/Header/components/PromoBar/PromoBarPropTypes';
import { socialsBarPropTypes } from '@Theme/natucare/modules/Header/components/SocialsBar/SocialsBarPropTypes';
import { searchResultsPropTypes } from './components/MainBar/components/SearchResults/SearchResultsPropTypes';
export const headerPropTypes = {
  promoBar: PropTypes.shape(promoBarPropTypes),
  mainBar: PropTypes.shape(mainBarPropTypes),
  socialsBar: PropTypes.shape(socialsBarPropTypes),
  onChange: PropTypes.func,
  searchResults: searchResultsPropTypes.searchResults,
  searchTerm: PropTypes.string,
  sendSearchData: PropTypes.func,
  isBlogPostTemplate: PropTypes.bool,
  ref: PropTypes.any
};